import React from 'react'
import { Box, Typography } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { setDateFormat, setTimeFormat } from '../../../../utils/dateUtils'
import { Grid } from '@mui/system'

interface EventDateTimeProps {
  startDate: Date | null
  endDate: Date | null
}

const EventDateTime: React.FC<EventDateTimeProps> = ({ startDate, endDate }) => {
  // Handle null or invalid dates
  if (!startDate || !endDate) {
    return <Typography variant='body1'>Date information is not available.</Typography>
  }

  const start = new Date(startDate)
  const end = new Date(endDate)

  // Check if the start and end are on the same day
  const isSameDay = start.toDateString() === end.toDateString()

  return (
    <Box>
      {!isSameDay ? (
        <Grid container spacing={{ xs: 0, xl: 2 }} direction={{ lg: 'column', xl: 'row' }}>
          <Box display='flex' alignItems='center'>
            <EventIcon sx={{ mr: 1 }} />
            <Typography variant='body1'>
              {setDateFormat(start)} at {setTimeFormat(start)}
            </Typography>
          </Box>
          <Box display='flex' alignItems='center'>
            <EventIcon sx={{ mr: 1 }} />
            <Typography variant='body1'>
              {setDateFormat(end)} at {setTimeFormat(end)}
            </Typography>
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={{ xs: 0, xl: 2 }} direction={{ lg: 'column', xl: 'row' }}>
          <Box display='flex' alignItems='center'>
            <EventIcon sx={{ mr: 1 }} />
            <Typography variant='body1'>{setDateFormat(start)}</Typography>
          </Box>
          <Box display='flex' alignItems='center'>
            <ScheduleIcon sx={{ mr: 1 }} />
            <Typography variant='body2'>
              {setTimeFormat(start)} - {setTimeFormat(end)}
            </Typography>
          </Box>
        </Grid>
      )}
    </Box>
  )
}

export default EventDateTime
